export enum ProcessStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    EXPIRED = 'EXPIRED',
}

export enum LiveLapseQualityEnum {
    SD = 'SD',
    HD = 'HD',
}

export enum LiveLapseTypeEnum {
    BASIC = 'BASIC',
    ADVANCED = 'ADVANCED',
}

export enum PublicApiRequestStatusEnum {
    PENDING = 'PENDING',
    COMPELETED = 'COMPELETED',
}
export enum CommentTypeEnum {
    ISSUE = 'ISSUE',
    ACTION = 'ACTION',
}
export enum CommentStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
}

export enum ProgressReportTypeEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    BIANNUALLY = 'BIANNUALLY',
    ANNUALLY = 'ANNUALLY',
}

export const ProcessStatusLabels: Record<ProcessStatusEnum, string> = {
    [ProcessStatusEnum.PENDING]: 'Pending',
    [ProcessStatusEnum.COMPLETED]: 'Completed',
    [ProcessStatusEnum.FAILED]: 'Failed',
    [ProcessStatusEnum.EXPIRED]: 'Expired',
};
export const PublicApiRequestStatusEnumLabels: Record<PublicApiRequestStatusEnum, string> = {
    [PublicApiRequestStatusEnum.PENDING]: 'Pending',
    [PublicApiRequestStatusEnum.COMPELETED]: 'Completed',
};

export const CommentTypeLabels: Record<CommentTypeEnum, string> = {
    [CommentTypeEnum.ISSUE]: 'Issue',
    [CommentTypeEnum.ACTION]: 'Action',
};

export const CommentStatusLabels: Record<CommentStatusEnum, string> = {
    [CommentStatusEnum.OPEN]: 'Open',
    [CommentStatusEnum.CLOSED]: 'Closed',
};

export enum WorkerLabelEnum {
    W = 'W',
    WH = 'WH',
    WV = 'WV',
    WHV = 'WHV',
}
export enum EquipmentLabelEnum {
    crane = 'crane',
    excavator = 'excavator',
    'backhoe loader' = 'backhoe loader',
    bulldozer = 'bulldozer',
    'dump truck' = 'dump truck',
    'concrete mixer' = 'concrete mixer',
    forklift = 'forklift',
    'skid steer' = 'skid steer',
    manlift = 'manlift',
    'boom lift' = 'boom lift',
    'mobile telescopic crane' = 'mobile telescopic crane',
}
